import {
  GET_SERVICES_REQUEST,
  GET_SERVICES_RESPONSE,
  ADD_SERVICE_REQUEST,
  EDIT_SERVICE_REQUEST,
  GET_SERVICE_DETAILS_REQUEST,
  GET_SERVICE_DETAILS_RESPONSE,
  DELETE_SERVICE_REQUEST,
  EDIT_SERVICE_BULK_REQUEST,
} from "./types";

// list
export const getServicesRequest = (payload) => ({
  type: GET_SERVICES_REQUEST,
  payload,
});

export const getServicesResponse = (payload) => ({
  type: GET_SERVICES_RESPONSE,
  payload,
});

// add
export const addServiceRequest = (payload, onSucess) => ({
  type: ADD_SERVICE_REQUEST,
  payload,
  onSucess
});

// edit
export const editServiceRequest = (payload, onsuccess) => ({
  type: EDIT_SERVICE_REQUEST,
  payload,
  onsuccess,
});

// edit bulk
export const editServiceBulkRequest = (payload, onsuccess) => ({
  type: EDIT_SERVICE_BULK_REQUEST,
  payload,
  onsuccess,
});

// get by id (view)
export const getServiceDetailsRequest = (payload) => ({
  type: GET_SERVICE_DETAILS_REQUEST,
  payload,
});

export const getServiceDetailsResponse = (payload) => ({
  type: GET_SERVICE_DETAILS_RESPONSE,
  payload,
});

export const deleteServiceRequest = (payload) => ({
  type: DELETE_SERVICE_REQUEST,
  payload,
});
